// import { nanoid } from 'nanoid'
import React from 'react'
// import { setObject } from '../../utils/useful'
// import FormViewer from '../FormViewer'
import { apisObject } from '../../variables/FetchInputApis'
// import SelectInput from './SelectInput'
import HttpServices from '../../utils/Http.services'
import FixedView from '../FixedView'
import ParamsStageList from './ParamsStageList'
import inputComponents from '../tableComponents'
import { checkTranslation } from '../../utils/useful'


class FieldValueInput extends React.Component {

    state = {
        apis: [],
    }


    componentDidMount() {

        this.init()
        setTimeout(() => {
            this.setState({ showFixedView: true })
        }, 10);

    }

    componentDidUpdate(prevProps) {
        if (prevProps.header?.information?.frame !== this.props.header?.information?.frame) {
            this.init()
        }
    }




    init() {




        if (this.props.header?.information?.frame) {
            let body = { filter: {} }

            if (!Array.isArray(this.props.header?.information?.frame)) {
                body.filter._id = [this.props.header?.information?.frame]
            } else {
                body.filter._id = this.props.header?.information?.frame
            }

            HttpServices.request('getFrames', body, (fetchResult, fetchError) => {


                this.setState({ isLoadingHeaders: false })
                if (fetchError) {
                    this.setState({ fetchError })
                    return
                }

                let apis = []


                // TO DO: CONSIDER ADDING THE FRAMES NAMES TO INDICATED DIFFERENT KEYS
                if (Array.isArray(fetchResult.info)) {

                    for (let i = 0; i < fetchResult.info.length; i++) {
                        const frame = fetchResult.info[i];

                        if (apisObject[frame.type]) {

                            apis = apisObject[frame.type].default ? JSON.parse(JSON.stringify(apisObject[frame.type].default)) : []

                            if (apisObject[frame.type][frame.mode]) {

                                apis = [...apis, ...(apisObject[frame.type][frame.mode] ?? [])]

                            }

                        }
                    }

                }





                this.setState({ apis }, () => {

                    if (apis.length == 1) {
                        this.changeValue(null, apis[0].value, null)
                    }

                })



            })
        } else {
            this.setState({ apis: [] }, () => { })
        }

    }


    changeValue = (key, value, extra) => {

        this.props.changeValue(this.props.header?.key, value, this.props.extra)

    }



    render() {

        let fieldType
        let Component = null
        let label
        let value
        let targetHeader
        let operator
        let target

        if (operator) {
            Component = inputComponents[fieldType]

            if (Component && !this.state.showFixedView) {
                setTimeout(() => {
                    if (!this.state.showFixedView) {
                        this.setState({ showFixedView: true })
                    }
                }, 10)
            }
        }





        return (
            <div className="text-smaller flexcc text-start text-bold postion-relative" style={{ padding:  '7px 10px', color: !Component ? "#10454580" : "#104545", whiteSpace: 'nowrap' }}>

                <div className="filter-input flexc "  >

                    {label && (
                        <div className="position-absolute " style={{ left: 10, width: 'calc(100% - 40px)' }}>
                            <p className="w-100" style={{ textOverflow: 'ellipsis', overflow: 'hidden', }}>{"{{"}{checkTranslation(label)}{"}}"}</p>
                        </div>
                    )}

                    {Component && (
                        <div className="flex-1 position-relative" style={{ alignSelf: 'stretch' }}>
                            <Component ref={(el) => this.componentInput = el} changeValue={this.changeTargetValue} data={value} header={targetHeader} setStatus={this.setStatus} variables={this.props.variables} tableCell={true} />
                        </div>
                    )}

                    <div className="flexcc">
                        <button ref={el => this.targetParamsBut = el} className=" font-size-12 mld-2 white br-20 text-semibold flexcc" style={{ backgroundColor: '#fff', padding: 4, boxShadow: '0px 0px 10px #10101010' }} onClick={() => this.targetFixedView.showView()}>
                            <img className="  " src="/assets/icons/useful/brackets-curly.svg" alt="" height={12} />
                        </button>


                        {this.state.showFixedView && (
                            <FixedView zIndex={10} ref={el => this.targetFixedView = el} nodeRef={this.targetParamsBut} xOffset={-12} bottomOffset={27} topOffset={5} width={180} maxWidth={180} >

                                <div className='bg-white br-10  shadow-3  w-100' style={{}}>

                                    <ParamsStageList params={this.props.params} data={target} changeValue={this.changeTargetValue}  optionsList={this.props.optionsList} asVariable={true} variables={this.props.variables} />

                                </div>
                            </FixedView>
                        )}
                    </div>

                </div>
            </div>
        );
    }
}

export default FieldValueInput;
